import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SubscriptionPlan, SubscriptionPlanCreate, SubscriptionPlanFilter } from '../data/subscriptionPlan';

export function createSubscriptionPlanService(client: AxiosInstance) {
  return createCrudService<SubscriptionPlan, SubscriptionPlanCreate, SubscriptionPlanFilter>(client, "/tenancy/SubscriptionPlan", "subscriptionPlanId");
}

export type SubscriptionPlanService = CrudService<
  SubscriptionPlan,
  SubscriptionPlanCreate,
  SubscriptionPlanFilter
>;
